<template>
    <div class="input-wrapper">
        <!-- v-if="labelText" -->
        <!-- :id="uniqueLabel" -->
        <label class="label form-label">
            <!-- {{ labelText }} -->
        </label>
        <div class="sfc-dropdown-container">
            <input
                v-model="inputValue"
                class="input form-control"
                @focus="dropdownShown = true"
            >
            </input>
            <div
                v-if="dropdownShown"
                class="dropdown-content"
            >
                <a
                v-if="!isFilteredAdviserListEmpty"
                    v-for="adviser in filteredAdviserList"
                    @click="selectAdviser(adviser)"
                >
                    <span v-html="highlightMatches(adviser.fullName)"></span>

                </a>
                <div class="p-3" v-else>
                    <h1 class="h4">{{microcopy?.cantFindAdviserHeading}}</h1>
                    <p v-html="microcopy?.cantFindAdviserBody"></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dropdownShown: false,
            inputValue: '',
            selectedAdviser: '',
            microcopy: null
        }
    },
    props: {
        advisers: {
            type: Array,
            required: true
        }
    },
    emits: ['selected-adviser'],
    methods: {
        highlightMatches(text) {
            if (!this.inputValue) return text;
            const regex = new RegExp(`(${this.inputValue})`, 'gi');
            return text.replace(regex, '<strong>$1</strong>');
        },
        selectAdviser(adviser) {
            this.selectedAdviser = adviser;
            this.inputValue = adviser.fullName;
            this.dropdownShown = false;
            this.$emit('selected-adviser', this.selectedAdviser);
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.dropdownShown = false;
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        this.microcopy = window.bookAnAppointmentReferralMicrocopy?.existingCustomer;

    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    computed: {
        filteredAdviserList() {
            return this.advisers.filter((element) => element.fullName.toLowerCase().includes(this.inputValue.toLowerCase()))
        },
        isFilteredAdviserListEmpty() {
            return this.filteredAdviserList.length === 0;
        }

    }

}
</script>
<style lang="scss" scoped>

.sfc-dropdown-container {
	position: relative;
}

.dropdown-content {
    position: absolute;
    background-color: white;
    border: 1px solid #ddd;
    border-top: none;
    z-index: 1;
    overflow-y: auto;
    max-height: 246px;
	top: 100%;
    width: 100%;
}

/* Links inside the dropdown */
.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
    background-color: #f1f1f1;
    text-decoration: underline !important;
    font-weight: 600 !important;
}
a {
    font-weight: 400;
}
</style>
